import React, { useEffect, useState } from 'react';

import s from './ArticleColophon.scss';
import { Container } from 'components/container/Container';
import { useIntl } from 'react-intl';

interface IProps {
  children?: React.ReactNode;
  date?: string;
  author: string;
  photographer?: string;
  tags?: string[];
  metadata?: Array<{
    title: string;
    value: string;
  }>;
  location?: any;
}

export const ArticleColophon = ({
  date,
  author,
  photographer,
  tags,
  metadata,
  children,
  location,
}: IProps) => {
  const [url, setUrl] = useState();

  useEffect(() => {
    if (location !== undefined) {
      setUrl(location.href);
    }
  }, [location]);

  const intl = useIntl();

  return (
    <Container>
      <div
        className={s('articleColophon', {
          hasChildren: children,
          large: metadata && metadata.length > 2,
        })}
      >
        <dl className={s.articleColophon__col}>
          {date && (
            <div className={s.articleColophon__colInner}>
              <dt className={s.articleColophon__heading}>
                {intl.formatMessage({ id: 'article.date', defaultMessage: 'Dagsetning' })}
              </dt>
              <dd className={s.articleColophon__dd}>{date}</dd>
            </div>
          )}
          {author && (
            <div className={s.articleColophon__colInner}>
              <dt className={s.articleColophon__heading}>
                {intl.formatMessage({ id: 'article.words', defaultMessage: 'Höfundur' })}
              </dt>
              <dd className={s.articleColophon__dd}>{author}</dd>
            </div>
          )}
          {photographer && (
            <div className={s.articleColophon__colInner}>
              <dt className={s.articleColophon__heading}>
                {intl.formatMessage({
                  id: 'article.photographer',
                  defaultMessage: 'Ljósmyndir eftir',
                })}
              </dt>
              <dd className={s.articleColophon__dd}>{photographer}</dd>
            </div>
          )}
          {metadata &&
            metadata.length > 0 &&
            metadata.map((item: { title: string; value: string }, i: number) => (
              <div key={i} className={s.articleColophon__colInner}>
                <dt className={s.articleColophon__heading}>{item.title}</dt>
                <dd className={s.articleColophon__dd}>{item.value}</dd>
              </div>
            ))}
        </dl>

        <div className={s.articleColophon__col}>
          <h3 className={s.articleColophon__heading}>
            {intl.formatMessage({ id: 'share', defaultMessage: 'Deila' })}
          </h3>
          <ul className={s.articleColophon__ul}>
            <li className={s.articleColophon__li}>
              <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
                Facebook
              </a>
            </li>
            <li className={s.articleColophon__li}>
              <a target="_blank" href={`https://twitter.com/intent/tweet?text=${url}`}>
                Twitter
              </a>
            </li>
            <li className={s.articleColophon__li}>
              <a
                target="_blank"
                href={`https://pinterest.com/pin/create/button/?url=${url}&media=`}
              >
                Pinterest
              </a>
            </li>
          </ul>
        </div>

        {tags && tags.length > 0 && (
          <div className={s.articleColophon__col}>
            <h3 className={s.articleColophon__heading}>
              {intl.formatMessage({ id: 'article.tags', defaultMessage: 'Tögg' })}
            </h3>
            <ul className={s.articleColophon__ul}>
              {tags.map((tag, i) => (
                <li className={s.articleColophon__li} key={i}>
                  {tag}
                </li>
              ))}
            </ul>
          </div>
        )}

        {children && <div className={s.articleColophon__cta}>{children}</div>}
      </div>
    </Container>
  );
};
